export const GET_PROMO_SLIDER = "GET_PROMO_SLIDER";
export const GET_PROMO_BANNER = "GET_PROMO_BANNER";
